import React from "react";
import Typography from "@mui/material/Typography";
import { nullCheck } from "../../../../utils/dataHelpers";
import { Box } from "@mui/system";

export default function CapacityDayCell(cell) {
  const row = nullCheck(cell, {}, "row", "original");
  const availableDaily = nullCheck(row, {}, "availableDaily");
 
  const days = [
    {
      day: "S",
      value: availableDaily.availableSunday
    },
    {
      day: "M",
      value: availableDaily.availableMonday
    },
    {
      day: "T",
      value: availableDaily.availableTuesday
    },
    {
      day: "W",
      value: availableDaily.availableWednesday
    },
    {
      day: "T",
      value: availableDaily.availableThursday
    },
    {
      day: "F",
      value: availableDaily.availableFriday
    },
    {
      day: "S",
      value: availableDaily.availableSaturday
    },
  ];

  return (
    <span style={{display: "flex", alignItems: "center"}}>
      {days.map((day, i) => (
        <Box key={`day-${i}`} sx={{display: "flex", marginRight: "10px"}}>
          <Typography variant="subhead1" color="black_solid.60" sx={{marginRight: "3px"}}>
            {day.day}
          </Typography>
          <Typography variant="subhead1" color="black_solid.80">
            {day.value || 0}
          </Typography>
        </Box>
      ))}
    </span>
  );
}